import { getFormCreatorStore, SetFormErrors } from '@/store/formCreator/actions';
import { FormErrorNames } from '@/store/formCreator/types';
import { clone, omit } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

export const useStep4Errors = () => {
    const { t } = useTranslation();
    const { errors } = useSelector(getFormCreatorStore);
    const dispatch = useDispatch();
    const isEmailInputError =
        !!errors?.[FormErrorNames.NOTIFY_INVALID_EMAILS] ||
        !!errors?.[FormErrorNames.NOTIFY_EMAILS_NEMBER_EXCEEDED] ||
        !!errors?.[FormErrorNames.NOTIFY_EMAILS_NOT_ON_CONTACT_LIST] ||
        !!errors?.[FormErrorNames.NOTIFY_EMAILS_NO_PROPER_SEPARATOR];
    const resetErrors = (): void => {
        if (!isEmailInputError) return;

        const errorsObject = clone(errors) || {};
        const errorsToOmit = [
            FormErrorNames.NOTIFY_INVALID_EMAILS,
            FormErrorNames.NOTIFY_EMAILS_NO_PROPER_SEPARATOR,
            FormErrorNames.NOTIFY_EMAILS_NEMBER_EXCEEDED,
            FormErrorNames.NOTIFY_EMAILS_NOT_ON_CONTACT_LIST
        ];
        const newErrorsObject = omit(errorsObject, errorsToOmit);
        dispatch(SetFormErrors(newErrorsObject));
    };
    const emailsInputErrorText = !!errors?.[FormErrorNames.NOTIFY_EMAILS_NEMBER_EXCEEDED]
        ? t('youcanenter5emails')
        : !!errors?.[FormErrorNames.NOTIFY_EMAILS_NO_PROPER_SEPARATOR]
        ? t('addressesmustbeseparatedbysemicolon')
        : !!errors?.[FormErrorNames.NOTIFY_EMAILS_NOT_ON_CONTACT_LIST]
        ? t('form_notificationcontact_error')
        : t('enteravalidemailadress');
    return { isEmailInputError, resetErrors, emailsInputErrorText };
};
